import React from 'react'
import { useIntl } from 'react-intl'

import { useQuoteTotalRows } from './useQuoteTotalRows'
import { QuoteSectionClientProposalPriceFragment } from '../../../../../../../../lib/graphql'
import { Card } from '../../../../../../../../shadcn/components/ui/card'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../../../../../../../shadcn/components/ui/table'
import { useCurrencyAreaContext } from '../../../../../../../contexts'

const QuoteSectionBodyTotalPrice = ({
  price,
}: {
  price: QuoteSectionClientProposalPriceFragment
}) => {
  const { currency } = useCurrencyAreaContext()
  const { totalRows, totalVATRows } = useQuoteTotalRows({ price, currency })
  const intl = useIntl()

  const totalHTLabel = intl.formatMessage({
    id: 'ui.QuoteSectionBodyTotalPrice.header.totalHT',
    defaultMessage: 'Total HT',
  })
  const totalTTCLabel = intl.formatMessage({
    id: 'ui.QuoteSectionBodyTotalPrice.header.totalTTC',
    defaultMessage: 'Total TTC',
  })

  return (
    <>
      <UpdateQuoteTotalSectionBlock
        headers={[totalHTLabel, totalTTCLabel]}
        rows={totalRows}
        title={intl.formatMessage({
          id: 'ui.QuoteSectionBodyTotalPrice.total.title',
          defaultMessage: 'Total',
        })}
      />
      <UpdateQuoteTotalSectionBlock
        headers={[totalHTLabel, totalTTCLabel]}
        rows={totalVATRows}
        title={intl.formatMessage({
          id: 'ui.QuoteSectionBodyTotalPrice.vat.title',
          defaultMessage: 'TVA',
        })}
      />
    </>
  )
}

export interface IRowProps {
  label: string
  values: {
    HT: string
    TTC: string
  }
  textColor?: string
}
interface IUpdateQuoteTotalSectionProps {
  title: string
  headers: string[]
  rows: IRowProps[]
}

const UpdateQuoteTotalSectionBlock = ({
  title,
  headers,
  rows,
}: IUpdateQuoteTotalSectionProps) => {
  return (
    <Card className='mt-10 w-full border-grey-500 shadow-none'>
      <Table className='w-full'>
        <TableHeader>
          <TableRow className='border-none'>
            <TableHead className='font-semibold text-black'>{title}</TableHead>
            {headers.map((header, index) => (
              <TableHead key={index} className='font-semibold text-black'>
                {header}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>

        <TableBody>
          {rows.map((row, index) => (
            <TableRow
              key={index}
              className={`border-none ${row.textColor || ''}`}
            >
              <TableCell>{row.label}</TableCell>
              <TableCell>{row.values.HT}</TableCell>
              <TableCell>{row.values.TTC}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Card>
  )
}

export default QuoteSectionBodyTotalPrice
